import '../CommonStyles.css';
import React, { useEffect, useState } from 'react';

import { connect, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import logo from '../../assets/img/CBRE_logo.svg';
import bg from '../../assets/img/header.jpg';
import Spinner from '../../Components/Spinner/Spinner';
import useQuery from '../../hooks/useQuery';
import * as actionTypes from '../../store/actions/index';
import { formatDatefromTimeStamp } from '../../utils/utils';

function CoverPageComponent(props) {
  const [IsSpinner, SetIsSpinner] = useState(false);
  const { surveyId } = useParams();
  const query = useQuery();
  const { data, displayDate, pdfDownload } = props;
  const currentDeal = useSelector((state) => state.comRed.currentDeal);
  const isPdfContent = useSelector((state) => state.comRed.pdfDownload);

  const deal_ID = 2329; //production id
  // let deal_ID = "2366";//local id
  const isShortlisted = query.get('isShortlisted');
  const isAPILoading = false;

  let targetMarket;

  const surveyData = data.survey;

  const getSurveyName = () => {
    if (currentDeal?.['Target Market']) {
      return currentDeal?.['Target Market'];
    }
  };

  const getPlannedDate = () => {
    if (currentDeal && currentDeal?.['Projected Move In Date']) {
      const date = new Date(currentDeal['Projected Move In Date']);
      const reqDate =
        date.toLocaleDateString('en-US', { day: 'numeric' }) +
        '-' +
        date.toLocaleDateString('en-US', { month: 'short' }) +
        '-' +
        date.toLocaleDateString('en-US', { year: 'numeric' });

      return reqDate;
    }
  };

  if (surveyData && surveyData.Client) {
    const text = surveyData.Client;

    targetMarket = text[0].toUpperCase() + text.substring(1);
  }

  useEffect(() => {
    if (!pdfDownload) {
      SetIsSpinner(true);
      props.setApiData(surveyId, isShortlisted, isAPILoading);
      props.setMajorProviders();

      setTimeout(() => {
        SetIsSpinner(false);
      }, 9000);
    }
    // eslint-disable-next-line
  }, []);
  const todaysDate = new Date();
  const dateT =
    todaysDate.toLocaleDateString('en-US', { day: 'numeric' }) +
    '-' +
    todaysDate.toLocaleDateString('en-US', { month: 'short' }) +
    '-' +
    todaysDate.toLocaleDateString('en-US', { year: 'numeric' });

  return (
    <div className="coverPage">
      {' '}
      {IsSpinner && <Spinner />}
      {displayDate && (
        <div className="dateDisplay">
          {data && data.id === '1642645604845x519251412791853060'
            ? dateT
            : formatDatefromTimeStamp(new Date(displayDate), 'DD-MMM-YYYY')}
          {/* // displayDate} */}
        </div>
      )}
      <img src={bg} alt="" className="cbreImg" style={{ width: '84%', marginLeft: '8%' }} />
      <div className="second-txt">
        {currentDeal && currentDeal['Target Market'] && (
          <div style={{ marginLeft: '60px' }}>
            <h3>
              {' '}
              Agile Real Estate Solutions <br />
              {currentDeal?.['Client Name']?.[0]}
            </h3>

            {currentDeal && currentDeal.DealID === deal_ID && (
              <div>
                {/* <div className="titleText">Presented to:</div> */}
                <div className="titleText">{getSurveyName() ? getSurveyName() : ''}</div>

                <div className="leftLine" style={{ height: '137px' }}></div>
                <div className="clientText">
                  <h5>Requirements Summary:</h5>
                  <ul style={{ display: isPdfContent ? 'inline-block' : 'list-item' }}>
                    <li>Initial requirement of 10-40 desks</li>
                    <li>Planned move in date is immediate</li>
                    {/* <li>Planned move in date: {getPlannedDate()}</li> */}
                    <li>Maximum flexibility for term and size is a priority</li>
                    <li>Close proximity to founders home is important</li>
                  </ul>
                </div>
              </div>
            )}
            {currentDeal && currentDeal.DealID !== deal_ID && (
              <div>
                <div className="titleText">{getSurveyName() ? getSurveyName() : ''}</div>
                <div className="leftLine"></div>
                <div className="clientText">
                  <h5>Requirements Summary:</h5>
                  <ul style={{ display: isPdfContent ? 'inline-block' : 'list-item' }}>
                    <li>
                      Desks Needed: {currentDeal?.['Projected Size']}
                      {currentDeal?.['Max Projected Size'] &&
                        currentDeal?.['Max Projected Size'] > 0 &&
                        currentDeal?.['Max Projected Size'] !== currentDeal?.['Projected Size'] && (
                          <span> - {currentDeal?.['Max Projected Size']}</span>
                        )}
                    </li>
                    <li>Planned move in date: {getPlannedDate()}</li>
                  </ul>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      <img src={logo} alt="" className="logoImg" />
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    data: state.optRed.data,
    displayDate: state.comRed.displayDate,
    pdfDownload: state.comRed.pdfDownload,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setApiData: (surveyId, isShortlisted, isAPILoading) =>
      dispatch(actionTypes.providerAction(surveyId, isShortlisted, false, isAPILoading)),
    setMajorProviders: () => dispatch(actionTypes.majorProviders()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CoverPageComponent);
